import React, { useState } from "react";
import { EuiFormRow, EuiFieldNumber } from "@elastic/eui";
import _ from "lodash";

function AbstractNumber({ options, errors, entityObject, register, onChange, selectedValue }) {
    const [value, setValue] = useState(selectedValue);

    const handleChange = ({ target: { value } }) => {
        setValue(value);
        if (onChange) {
            onChange(value);
        }
    };

    return (
        <EuiFormRow
            fullWidth
            label={options.label}
            key={options.name}
            helpText={options.helpText}
            isInvalid={errors && !_.isNil(errors[options.name])}
            error={options.errorMessage}
        >
            <EuiFieldNumber
                fullWidth
                name={options.name}
                defaultValue={entityObject && entityObject[options.name]}
                onChange={handleChange}
                min={options.min || 0}
                value={value}
                inputRef={
                    register &&
                    register({
                        ...options.validation,
                    })
                }
            />
        </EuiFormRow>
    );
}

export default AbstractNumber;
